<template>
  <div class="L-body">
    <div class="container h-100">
      <div class="d-flex justify-content-center h-100 align-items-center">
        <div class="card-login row text-center">
          <form class="login-form">
            <h1 class="bg-color-wh text-center">
              {{ $appName }}
            </h1>
            
            <div :class="`form-group position-relative ${hasError ? 'has-error' : ''}`">
              <input
                type="email"
                placeholder="ایمیل یا نام‌کاربری"
                required="true"
                v-model="login.login"
                class="form-control curve text-center"
                id="username"
              />
            </div>
            
            <div :class="`form-group position-relative ${hasError ? 'has-error' : ''}`">
              <div class="password-input-wrapper">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control curve text-center"
                  placeholder="کلمه‌عبور"
                  required
                  v-model="login.password"
                  style="padding-left: 15px; padding-right: 50px;"
                />
                <span class="password-toggle-wrapper" @click="togglePassword">
                  <!-- آیکن چشم باز (پسورد دیده می‌شود) -->
                  <svg 
                    v-if="showPassword" 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                  >
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  
                  <!-- آیکن چشم بسته (پسورد دیده نمی‌شود) -->
                  <svg 
                    v-else 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                  >
                    <path d="M17.94 17.94L6.06 6.06"/>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </span>
              </div>
            </div>

            <h5 class="bg-color-wh text-left">
              <a class="bg-color-wh" href="https://koochebazaar.com/users/profile/edit">رمز عبور / نام کاربری را فراموش کرده ام</a>
            </h5>
            
            <h3 v-if="hasError" class="text-danger">
              {{ errorMessage }}
            </h3>
            
            <button type="submit" @click.prevent="logUserIn" class="btn btn-primary blue w-100 mb-5">
              ورود به سامانه
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/auth";
export default {
  data() {
    return {
      login: {
        login: "",
        password: "",
      },
      hasError: false,
      errorMessage: "",
      showPassword: false,
    };
  },
  mounted() {
    this.$setLayout("simple-layout");
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    logUserIn() {
      if (!this.login.login || !this.login.password) {
        this.hasError = true;
        this.errorMessage = "اطلاعات کامل وارد نشده است";
        return;
      }
      this.$setIsLoading(true);
      api.getCsrf().then(() => {
        api
          .login(this.login)
          .then((res) => {
            this.$store.dispatch("login", res.data);
            this.$router.push("/");
          })
          .catch((error) => {
            this.hasError = true;
            this.errorMessage = error.response?.data?.message;
          })
          .finally(() => {
            setTimeout(() => {
              this.$setIsLoading(false);
            }, 500);
          });
      });
    },
  },
};
</script>

<style scoped>
.L-body {
  background-image: url("https://koochebazaar.com/uploads/texteditor/NbQyySiH6PJ2HH288wZyIeHZ7FegBBIo0gob7594.jpg");
  background-size: cover;
  height: 100% !important;
}

.card-login {
  width: 900px;
  border-radius: 8px;
  color: #ffffff99;
}

.login-form {
  width: 40%;
  margin: auto;
}

.curve {
  border-radius: 6px;
}

.blue {
  background-color: #124abb !important;
  border-color: #124abb !important;
  border-radius: 6px !important;
}

.bg-color-wh {
  color: white !important;
}

.card-header-login {
  background-color: #0009;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 14px;
  font-size: 21px;
  text-align: center;
}

.card-body-login {
  padding: 30px;
  background-color: #1f1f1f7f;
}

.form-control {
  box-shadow: none !important;
  color: black !important;
}

/* استایل اصلی برای wrapper */
.password-input-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
}

/* استایل input */
.password-input-wrapper input {
  width: 100%;
  padding-right: 45px !important; /* فاصله برای آیکن چشم */
  padding-left: 15px !important;
  text-align: center !important;
  direction: rtl;
  border: 1px solid #ced4da;
  height: calc(2.25rem + 2px);
  font-size: 16px;
}

/* استایل آیکن toggle - دقیقاً مشابه تغییر رمز */
.password-toggle-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  z-index: 10;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

/* استایل SVGها - مشابه کامپوننت دیگر */
.password-toggle-wrapper svg {
  width: 20px;
  height: 20px;
  stroke: #6c757d;
  transition: stroke 0.2s;
  display: block;
}

.password-toggle-wrapper:hover svg {
  stroke: #6c757d;
}

/* وقتی input focus است */
.password-input-wrapper input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* برای حالت ریسپانسیو */
@media (max-width: 768px) {
  .login-form {
    width: 80%;
  }
  
  .password-toggle-wrapper {
    right: 10px;
  }
  
  .password-input-wrapper input {
    padding-right: 40px !important;
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .login-form {
    width: 90%;
  }
  
  .card-login {
    width: 100%;
  }
  
  .password-toggle-wrapper {
    right: 8px;
  }
  
  .password-input-wrapper input {
    padding-right: 35px !important;
  }
  
  .password-toggle-wrapper svg {
    width: 18px;
    height: 18px;
  }
}
</style>

<style>
/* استایل global برای حالت error */
.password-input-wrapper input.is-invalid {
  border-color: #dc3545 !important;
  padding-right: 50px !important;
  padding-left: 50px !important; /* فاصله برای آیکن error */
  background-position: left 15px center !important;
  background-size: 20px 20px !important;
}

/* آیکن toggle حتی وقتی error هست */
.password-input-wrapper input.is-invalid ~ .password-toggle-wrapper {
  right: 12px !important;
  z-index: 11 !important; /* بالاتر از background */
}

/* برای هماهنگی با کامپوننت تغییر رمز */
.password-toggle-wrapper svg {
  vertical-align: middle;
}
</style>